import type { ReactNode } from 'react';
import { useSwipe } from '../lib/swipe';

/**
 * Řádek s akcemi odhalenými swipem doleva (mobil) nebo najetím (desktop, CSS `.swipe:hover`).
 * Obsah zůstává klikací; akce jsou tlačítka vpravo.
 */
export function SwipeRow({
  children,
  actions,
  className = '',
}: {
  children: ReactNode;
  actions: { label: string; onClick: () => void; kind?: 'primary' | 'danger' }[];
  className?: string;
}) {
  const swipe = useSwipe();
  if (!actions.length) return <>{children}</>;
  return (
    <div className={`swipe ${swipe.open ? 'open' : ''} ${className}`.trim()}>
      <div className="swipe-actions">
        {actions.map((a) => (
          <button
            type="button"
            key={a.label}
            className={`swipe-btn ${a.kind ?? ''}`.trim()}
            onClick={() => {
              swipe.close();
              a.onClick();
            }}
          >
            {a.label}
          </button>
        ))}
      </div>
      <div
        className="swipe-content"
        style={{ transform: `translateX(${swipe.offset}px)` }}
        {...swipe.handlers}
      >
        {children}
      </div>
    </div>
  );
}
